import {
  GetArticleBySlug_getArticleBySlug_sourceInterviewee,
  GetArticleBySlug_getArticleBySlug_sourceInterviewer,
  GetArticleBySlug_getArticleBySlug_store,
} from 'api/articles/types/GetArticleBySlug';
import ArticleAthleteBox, {
  ArticlePerson,
} from '../ArticleAthleteBox/ArticleAthleteBox';
import styles from './ArticleParticipants.module.scss';

type ArticleParticipantsProps = {
  store: GetArticleBySlug_getArticleBySlug_store | null;
  interviewer: GetArticleBySlug_getArticleBySlug_sourceInterviewer | null;
  interviewee: GetArticleBySlug_getArticleBySlug_sourceInterviewee | null;
  isInterview: boolean;
};

const toPerson = (
  user:
    | GetArticleBySlug_getArticleBySlug_sourceInterviewer
    | GetArticleBySlug_getArticleBySlug_sourceInterviewee
    | null
): ArticlePerson | null =>
  user?.slug
    ? {
        slug: user.slug,
        name:
          user.storeDetails?.storeName ||
          `${user.firstName} ${user.lastName}`.trim(),
        avatarURL: user.storeDetails?.avatarURL,
      }
    : null;

const ArticleParticipants = ({
  store,
  interviewer,
  interviewee,
  isInterview,
}: ArticleParticipantsProps): JSX.Element | null => {
  const storePerson: ArticlePerson | null = store?.slug
    ? {
        slug: store.slug,
        name: store.storeDetails?.storeName || store.slug,
        avatarURL: store.storeDetails?.avatarURL,
      }
    : null;
  // Older interview articles have no sourceInterviewee: their store is the interviewee.
  const subject = (isInterview && toPerson(interviewee)) || storePerson;

  if (!subject) {
    return null;
  }

  const host = isInterview ? toPerson(interviewer) : null;

  return (
    <section className={styles.root} aria-labelledby="article-participants">
      <h2 id="article-participants" className={styles.title}>
        {isInterview ? 'In this interview' : 'About the athlete'}
      </h2>
      <div className={styles.list}>
        <ArticleAthleteBox
          person={subject}
          label={isInterview ? 'Interviewee' : 'Athlete'}
        />
        {host && host.slug !== subject.slug && (
          <ArticleAthleteBox person={host} label="Interviewed by" />
        )}
      </div>
    </section>
  );
};

export default ArticleParticipants;
